import { ClientEntity } from 'src/app/models/clients';
import { ICashflowAvailableData } from "src/app/models/cashflow";
import { IPortfolio } from "../../models/portfolios";

export interface ICashflowState {
    cashflowAvailableData: ICashflowAvailableData;
    selectedDate?: Date;
    selectedEntities?: ClientEntity[];
    selectedPortfolios?: IPortfolio[];
    loading: boolean;
    error: boolean;
    errorMessage: string;
}

export const initialCashflowState: ICashflowState = {
    cashflowAvailableData: null,
    loading: false,
    error: false,
    errorMessage: ''
};
